<template>
  <teleport v-if="widget" to="#crentLocationMap">
    <div
      class="orm-py-16 orm-pb-60 orm-container-fluid orm-background__image"
      v-if="backgroundImage"
      :style="{
        backgroundImage: 'url(' + backgroundImage + ')',
      }"
    >
      <div class="orm-container">
        <div class="orm-row center-xs">
          <div
            class="orm-searchbar__datepicker orm-col-xs-12 orm-col-sm-11 orm-col-md-11 orm-col-lg-11"
          >
            <h2
              class="orm-locationMap__title"
              :class="
                headlinemode == 'dark' ? 'orm-locationMap__title--dark' : ''
              "
            >
              <span v-html="i18n('modules/locationmap/title')"></span>
            </h2>
            <div
              class="orm-searchbar__padding orm-searchbar__padding--map"
              v-if="ormload"
            >
              <gMap
                :mapConfig="mapConfig"
                :apiKey="apiKey"
                :height="200"
                :markers="stations"
                v-slot="{ google, map, bounds }"
                v-if="cookiefound.maps"
                class="orm-searchlocmap orm-searchlocmap--radius orm-mb-16 overflowHidden"
              >
                <div v-for="marker in stations" :key="marker.station">
                  <gMapMarker
                    v-if="marker.latitude != 0 && marker.latitude != null"
                    :marker="marker"
                    :google="google"
                    :map="map"
                    :bounds="bounds"
                  />
                </div>
                <gMapUser
                  :google="google"
                  :map="map"
                  :bounds="bounds"
                  v-if="locateUser"
                />
              </gMap>
              <div
                v-else
                style="
                  background-color: #fff;
                  height: 100%;
                  min-height: 200px;
                  align-items: center;
                  display: flex;
                "
              >
                <div
                  class="orm-px-32"
                  v-html="i18n('modules/locationmap/noconsent')"
                ></div>
              </div>
              <div class="orm-row center-lg">
                <div class="orm-col-xs-12 orm-col-md-12 orm-col-lg-3">
                  <div class="orm-row">
                    <FormSelect
                      v-if="
                        sttype == 'ALL' &&
                          stations &&
                          tabbar &&
                          tabbar.length > 1
                      "
                      :data="tabbar"
                      :selected="stationtype"
                      v-model="stationtype"
                      @update:modelValue="setStationType(stationtype)"
                      class="orm-col-xs-12 orm-col-lg-12"
                    ></FormSelect>
                    <stationpicker
                      :data="stations"
                      type="start"
                      class="orm-col-xs-12 orm-col-lg-12"
                    />
                    <stationpicker
                      v-if="
                        store.getters['ORMgeneral/GET_PARAMETER'](
                          'BINET_ALLOW_ONEWAY'
                        ) == 1 && stationtype != 'ABO'
                      "
                      :data="stations"
                      viewType="mapModule"
                      type="end"
                      class="orm-col-xs-12 orm-col-sm-6 orm-col-lg-12"
                    />
                  </div>
                </div>
                <div
                  class="orm-col-xs-12 orm-col-lg-7 orm-datepicker--mobileView"
                  style="position: relative"
                >
                  <datepicker v-if="stationtype != 'ABO'" />
                  <datepicker_abo v-else />
                </div>
                <div
                  class="orm-relative orm-col-xs-12 orm-mb-16"
                  v-if="store.getters['ORMgeneral/GET_PARAMETER']('BORM_PRESELECT_PLANNED_KM') === '1' && stationtype != 'ABO'"
                >
                  <div class="orm-searchbar__headline">
                    {{
                      i18n("general/plannedDistance") || "Geplante Kilometer"
                    }}
                  </div>
                  <KmInput />
                </div>
                <div
                  class="text-right orm-col-xs-12 orm-col-sm-6 orm-col-sm-offset-6 orm-col-lg-2 orm-col-lg-offset-0"
                >
                  <button
                    v-if="!loading"
                    @click="getCars('/reservation/step1')"
                    class="orm-btn orm-btn--large orm-btn--searchbar"
                    :class="[station ? '' : 'disable']"
                  >
                    {{ i18n("general/search") }}
                  </button>
                  <button
                    class="orm-btn orm-btn--large orm-btn--searchbar disable"
                    v-else
                  >
                    <i class="fa fa-spinner-third orm-rotate360"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { defineComponent, reactive } from "vue";
import { mapSettings } from "@/constants/mapSettings";

import gMap from "@/components/maps/gMap.vue";
import gMapMarker from "@/components/maps/gMapMarker.vue";
import gMapUser from "@/components/maps/gMapUser.vue";

import datepicker from "@/components/ui/datepicker.vue"; // @ is an alias to /src
import datepicker_abo from "@/components/ui/datepicker_abo.vue"; // @ is an alias to /src
import stationpicker from "@/components/ui/stationpicker.vue"; // @ is an alias to /src
import FormSelect from "@/components/ui/INPUTS/FormSelectSimpleArray"; // @ is an alias to /src
import KmInput from "@/components/ui/km-input.vue";
import store from "@/store";
import i18n from "@/mixins/mixins";
import { buildDataLayer } from "@/constants/analytics";
import { routeToSteps } from "@/constants/getRoutes";

// import routes from "@/router/index";

export default defineComponent({
  name: "SearchBar",
  components: {
    datepicker,
    datepicker_abo,
    stationpicker,
    gMap,
    gMapMarker,
    gMapUser,
    FormSelect,
    KmInput,
  },
  mixins: [i18n],
  setup() {
    let widget = false;
    const myEle = document.getElementById("crentLocationMap");
    let sttype = "ALL";
    let headlinemode = "dark";
    let locateUser = false;
    if (myEle !== null) {
      widget = true;
      headlinemode = myEle.dataset.headline;

      if (document.getElementById("crentReservation").dataset.locateuser) {
        if (
          document.getElementById("crentReservation").dataset.locateuser ===
          "false"
        ) {
          locateUser = false;
        }
      }
    }
    const env = process.env;
    sttype = document.getElementById("crentReservation").dataset.stationtype;

    if (
      !store.getters["userSession/GET_STATIONTYPE"] ||
      (sttype !== "ALL" &&
        sttype !== !store.getters["userSession/GET_STATIONTYPE"])
    ) {
      // console.log("patch", sttype);
      store.dispatch("userSession/SET_STATIONTYPE", sttype);
      if (store.getters['ORMgeneral/GET_PARAMETER'](
          'BORM_PRESELECT_STATION'
      ) === '1') {
        store.dispatch(
            "userSession/SET_STATION",
            store.getters["stations/GET_STATIONS_FILTERED"][sttype][0].id
        );
      }
    }
    const cookiefound = reactive({ maps: true });
    const mapConfig = {
      ...mapSettings,
      center: { lat: 52.29240999999999, lng: 8.920219999999972 },
    };
    const clientdata = store.getters["general/GET_CLIENT_DATA"];

    const apiKey = clientdata["maps_apikey"];

    let backgroundImage;
    const GET_ORMIMAGE = store.getters["general/GET_ORMIMAGE"]("locationmapbg");
    if (GET_ORMIMAGE) {
      backgroundImage = GET_ORMIMAGE;
    } else if (clientdata["locationmap_background"]) {
      if (clientdata["locationmap_background"].search("http") != "-1") {
        // eslint-disable-next-line
        backgroundImage = clientdata["locationmap_background"];
      } else {
        // eslint-disable-next-line
        backgroundImage =
          process.env.VUE_APP_BASE_URL + clientdata["locationmap_background"];
      }
    }

    if (
      document.getElementById("crentLocationMap").dataset.image != "" &&
      document.getElementById("crentLocationMap").dataset.image
    ) {
      backgroundImage = document.getElementById("crentLocationMap").dataset
        .image;
    }
    backgroundImage = '"' + backgroundImage + '"';

    if (process.env.VUE_APP_COOKIECONSENT === "true") {
      const COOKIE = Symbol("Cookie");
      let lastCookies = document.cookie;

      const getCookie = (cname) => {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(lastCookies);
        const ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == " ") {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return JSON.parse(c.substring(name.length, c.length));
          }
        }
        return false;
      };

      const checkMapCookie = () => {
        if (process.env.VUE_APP_COOKIECONSENTARRAY === "true") {
          const cookie = getCookie(process.env.VUE_APP_COOKIECONSENTCOOKIENAME);
          // console.log(cookie);
          if (cookie.options) {
            cookiefound.maps = cookie.options.find(
              (element) =>
                element === process.env.VUE_APP_COOKIECONSENTCOOKIEMAPSNAME
            );
          } else if (cookie.checkboxes) {
            cookiefound.maps = cookie.checkboxes.find(
              ({ name }) =>
                name === process.env.VUE_APP_COOKIECONSENTCOOKIEMAPSNAME
            ).checked;
          }
        } else {
          if (
            getCookie(process.env.VUE_APP_COOKIECONSENTCOOKIEMAPSNAME) ==
            (true || 1)
          ) {
            cookiefound.maps = true;
          } else {
            cookiefound.maps = false;
          }
        }
      };

      Object.defineProperty(
        Document.prototype,
        COOKIE,
        Object.getOwnPropertyDescriptor(Document.prototype, "cookie")
      );

      Object.defineProperty(Document.prototype, "cookie", {
        enumerable: true,
        configurable: true,
        get() {
          return this[COOKIE];
        },
        set(value) {
          this[COOKIE] = value;

          if (value === lastCookies) {
            return;
          }
          lastCookies = value;
          checkMapCookie();
        },
      });
      checkMapCookie();
    } else {
      cookiefound.maps = true;
    }

    return {
      widget,
      store,
      mapConfig,
      cookiefound,
      apiKey,
      sttype,
      headlinemode,
      env,
      backgroundImage,
      locateUser,
    };
  },
  props: {
    origin: {
      type: String,
      default: "home",
      required: false,
    },
  },
  data() {
    return {
      station: Object,
      loading: false,
      ormload: false,
      clientdata: null,
      // backgroundImage: "",
      stations: {},
      stationsFilter: null,
      stationtype: null,
      tabbar: [],
    };
  },
  async mounted() {
    this.ormload = await store.getters["general/GET_ORMLOADED"];
    this.stations = await store.getters["stations/GET_STATIONS"];
    this.station = await store.getters["userSession/GET_STATION"];
    this.clientdata = await store.getters["general/GET_CLIENT_DATA"];
    // eslint-disable-next-line
    // if (this.clientdata["searchbar_background"]) {
    //   // eslint-disable-next-line
    //   this.backgroundImage = this.clientdata["searchbar_background"];
    // }
    this.stationsFilter = await store.getters["stations/GET_STATIONS_FILTERED"];
    this.stationtype = await store.getters["userSession/GET_STATIONTYPE"];
    this.stations = this.stationsFilter[this.stationtype];

    for (const station in this.stationsFilter) {
      if (station !== "ALL") this.tabbar.push(station);
    }

    store.watch(
      // eslint-disable-next-line
      (state, getters) => getters["general/GET_ORMLOADED"],
      (val) => {
        this.ormload = val;
        this.stations = store.getters["stations/GET_STATIONS"];
        this.station = store.getters["userSession/GET_STATION"];
      }
    );

    store.watch(
      // eslint-disable-next-line
      (state, getters) => getters["userSession/GET_STATION"],
      (val) => {
        this.station = store.getters["stations/GET_STATION_BY_ID"](val);
      }
    );
  },
  methods: {
    async getCars() {
      const times = await store.getters["stations/GET_OPENINGTIMES"];
      if (this.stationtype === "ABO") {
        store.dispatch("reservation/SET_DRIVEDISTANCE", null);
      }

      if (times) {
        this.loading = true;
        buildDataLayer("orm_reservation_begin", {}, "locationmap");
        routeToSteps(this, 1);
      }
    },
    async setStationType(type) {
      this.stationtype = type;
      await store.dispatch("userSession/SET_STATIONTYPE", type).then(() => {
        if (store.getters['ORMgeneral/GET_PARAMETER'](
            'BORM_PRESELECT_STATION'
        ) === '1') {
          store.dispatch(
              "userSession/SET_STATION",
              this.stationsFilter[type][0].id
          );
        }
        store.dispatch("userSession/SET_STATION_END", "startend");

        this.stations = this.stationsFilter[type];
      });
    },
  },
});
</script>
